import { render, staticRenderFns } from "./fleg-comp-actualizacion-y-recargos.vue?vue&type=template&id=df8e7f2e&lang=html&"
import script from "./fleg-comp-actualizacion-y-recargos.vue?vue&type=script&lang=js&"
export * from "./fleg-comp-actualizacion-y-recargos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports